import { useCallback } from "react"
import { useTranslation } from "react-i18next"

import { toast } from "@/hooks/use-toast"

/**
 * Copia um valor para a área de transferência e avisa o resultado REAL.
 *
 * `navigator.clipboard.writeText` devolve uma promise que rejeita fora de contexto seguro
 * (HTTP, iframe sem permissão) e quando o navegador nega a permissão. Disparar sem esperar
 * faz a tela avisar "copiado" nesses casos — e a pessoa cola no chamado o que estava no
 * clipboard antes, sem saber. Aqui o aviso só sai depois do resultado.
 *
 * @returns Função que copia o valor; `true` quando copiou de fato.
 */
export const useCopyToClipboard = () => {
  const { t } = useTranslation()

  return useCallback(
    async (value: string, message?: string) => {
      try {
        await navigator.clipboard.writeText(value)
        toast({
          title: message ?? t("common.copied"),
          variant: "success",
        })
        return true
      } catch {
        toast({
          title: t("common.copyError"),
          variant: "destructive",
        })
        return false
      }
    },
    [t]
  )
}
